// @flow
import type { ID_TYPE } from '../types/common';

import type {
  TEMPORARY_EVENT_ADDED_TYPE,
  TEMPORARY_EVENT_STARTED_TYPE,
  TEMPORARY_EVENT_COMPLETED_TYPE,
  TEMPORARY_EVENT_CANCELLED_TYPE,
} from '../types/temporaryEvents';
import * as types from '../types/temporaryEvents';


export const add = (
  id: ID_TYPE,
  lifespan: number,
  data?: Object,
  group?: string,
  active?: boolean,
): TEMPORARY_EVENT_ADDED_TYPE => ({
  type: types.TEMPORARY_EVENT_ADDED,
  payload: {
    id,
    lifespan,
    group,
    data,
    active,
  },
});

export const trigger = (
  id: ID_TYPE,
): TEMPORARY_EVENT_STARTED_TYPE => ({
  type: types.TEMPORARY_EVENT_STARTED,
  payload: {
    id,
    active: true,
  },
});

export const complete = (id: ID_TYPE): TEMPORARY_EVENT_COMPLETED_TYPE => ({
  type: types.TEMPORARY_EVENT_COMPLETED,
  payload: {
    id,
    isCompleted: true,
  },
});

export const cancel = (id: ID_TYPE): TEMPORARY_EVENT_CANCELLED_TYPE => ({
  type: types.TEMPORARY_EVENT_CANCELLED,
  payload: {
    id,
    isCanceled: true,
  },
});



// WEBPACK FOOTER //
// ./src/scripts/actions/temporaryEvents.js